import React, { Component } from 'react';
import Inherit from '../../core/inherit';
import withNavigate from '../../core/withNavigate';
import ContractsController from './contracts.controller';
import { Button } from 'antd';
import { FileText, Plus } from 'lucide-react';

import { Layout, TableSkeleton, AnalyticsSkeleton, PageHeader } from '../common';
import { ContractActions, ContractDrawer, ContractsTable, ContractAnalytics } from './elements';

class ShelfContracts extends Inherit(ContractsController, Component) {
    state = {
        isOpen: false,
        loading: true,
        contracts: [],
        rows: [],
        stores: [],
        clients: [],
        filters: null,
        investment: null,
        editMode: false,
        editingContract: null
    };

    render() {
        const { rows, loading, isOpen, stores, clients, investment, editMode, editingContract } = this.state;

        return (
            <Layout current="contracts">
                {this.props.contextHolder}

                <PageHeader
                    icon={<FileText />}
                    title="Contrataciones"
                    description="Gestiona las contrataciones de espacios en tienda"
                    actions={
                        <Button type="primary" icon={<Plus />} onClick={() => this.setIsOpen(true)} disabled={loading}>
                            Nueva Contratación
                        </Button>
                    }
                />

                {loading ? (
                    <div className="space-y-4">
                        <AnalyticsSkeleton count={4} />
                        <TableSkeleton rows={10} columns={8} />
                    </div>
                ) : (
                    <div className="space-y-4">
                        {/* Analytics — los totales responden a los filtros aplicados */}
                        <ContractAnalytics contracts={rows} investment={investment} />

                        {/* Filters & Table */}
                        <ContractActions onFilter={this.applyContractFilters.bind(this)} stores={stores} clients={clients} />
                        <ContractsTable
                            rows={rows}
                            loading={loading}
                            navigateContract={this.navigateContract.bind(this)}
                            onEdit={this.openEditDrawer.bind(this)}
                        />
                        <ContractDrawer
                            contextHolder={this.props.contextHolder}
                            isOpen={isOpen}
                            setIsOpen={this.setIsOpen.bind(this)}
                            createContract={this.createContract.bind(this)}
                            updateContract={this.updateContract.bind(this)}
                            stores={stores}
                            editMode={editMode}
                            contractData={editingContract}
                        />
                    </div>
                )}
            </Layout>
        );
    }
}

export default withNavigate(ShelfContracts);
